/**
 * 判斷是否微信
 */
export function isWeiXin () {
  let ua = window.navigator.userAgent.toLowerCase()
  /* eslint-disable */
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * url编码
 */
export function urlencode (str) {  
  str = (str + '').toString();   
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
  replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
}

/**
 * url编码
 */
export function deepClone (obj) {
  if (typeof obj !== 'object' || obj === null) return obj;
  const result = Array.isArray(obj) ? [] : {};
  for (const key in obj) {
    result[key] = deepClone(obj[key]); // 递归处理
  }
  return result;
}